const trimNumber = (number: number) => {
  if(!number || Number.isNaN(number) || number === Infinity) return 0
  if (Number.isInteger(number)) {
    return number.toString();
  } else {
    const roundedNumber = Math.round(number * 100) / 100;
    const stringNumber = roundedNumber.toString();
    const splitParts = stringNumber.split('.');
    if (splitParts.length > 1) {
      let decimalPart = splitParts[1];
      if (decimalPart.length > 1) {
        decimalPart = decimalPart.padEnd(2, '0');
      }
      return `${splitParts[0]}.${decimalPart}`;
    } else {
      return `${splitParts[0]}`;
    }
  }
}

export default trimNumber;